import { useState, useCallback } from 'react';
import { SnackbarMessage } from './types';

export const useSnackbar = () => {
  const [snackbars, setSnackbars] = useState<SnackbarMessage[]>([]);

  const generateId = () => `snackbar-${Date.now()}-${Math.random()}`;

  const removeSnackbar = useCallback((id: string) => {
    setSnackbars((prev) => prev.filter((snackbar) => snackbar.id !== id));
  }, []);

  const showSnackbar = useCallback((message: Omit<SnackbarMessage, 'id'>) => {
    const id = generateId();

    const newSnackbar: SnackbarMessage = {
      ...message,
      id,
    };

    setSnackbars(() => [newSnackbar]);
  }, []);

  const hideSnackbar = useCallback(
    (id: string) => {
      removeSnackbar(id);
    },
    [removeSnackbar],
  );

  const clearAll = useCallback(() => {
    setSnackbars([]);
  }, []);

  return {
    snackbars,
    showSnackbar,
    hideSnackbar,
    clearAll,
  };
};
